import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
  Typography,
} from "@mui/material";
import { FaAngleDown } from "react-icons/fa";

import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { endpoint } from "views/pages/manage/common/constant";
import { uuidValidateV4 } from "../helper";
import moment from "moment";

const MAX_BATCH_SELECTION = 4;
const MultiBatchLectureAccordion = ({
  form,
  setForm,
  formData,
  batchDetails,
  academicPlanId,
}) => {
  const [batchOptions, setBatchOptions] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  useEffect(() => {
    // search batches & load options
    searchBatchOptions();

    if (formData?.id && !uuidValidateV4(formData?.id)) getBreakoutBatches();
    // getBreakoutBatchesByEventId
  }, []);

  const searchBatchOptions = async () => {
    const payload = {
      academicPlanIds: [academicPlanId],
      timeTableStatus: "P",
      batchStatus: "ACTIVE",
      batchIdsNotIn: [batchDetails.id],
      onlineBatch: true,
      batchEndDateTo: moment().endOf("day"),
    };

    const response = await fetchAllPostPromisedData(
      `${endpoint.batchList.fetchAllBatches}=-1`,
      payload,
      "post",
      false
    );

    if (response.code === 200) {
      setBatchOptions(
        response.data.batchSearchResponseDTOList.map((obj) => ({
          value: obj.id,
          label: obj.batchName,
        }))
      );
    } else setBatchOptions([]);
    return;
  };

  const getBreakoutBatches = async () => {
    const response = await fetchAllPromisedData(
      `${endpoint.timetable.getBreakoutBatchesByEventId}/${formData.id}`
    );

    const breakoutBatchList = response?.breakoutBatchList?.map((obj) => ({
      label: obj.batchName,
      value: obj.batchId,
    }));

    setForm((prev) => ({ ...prev, breakoutBatchList }));
  };

  const removeSelectedBatch = (batch) => {
    const modifiedBatchList = form.breakoutBatchList.filter(
      (item) => item.value !== batch.value
    );
    setForm((prev) => ({ ...prev, breakoutBatchList: modifiedBatchList }));
  };

  const handleSelectedBatch = (batches) => {
    const firstFourBatches = batches.slice(0, MAX_BATCH_SELECTION);
    setForm((prev) => ({ ...prev, breakoutBatchList: firstFourBatches }));
  };

  return (
    <>
      <Drawer
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(false)}
        anchor={"right"}
        sx={{
          "& .MuiDrawer-paper": {
            width: "350px",
            padding: "1rem",
          },
        }}
        className="p-4"
      >
        <h3>Select Batches</h3>
        <AAutoComplete
          placeholder="Search Batches (max 4)"
          items={batchOptions}
          currentValue={form?.breakoutBatchList}
          isShowCount={true}
          isMulti={true}
          handleChange={(value) => {
            handleSelectedBatch(value);
          }}
          height="41px"
          //    isDisabled={}
        />

        <div className="mt-auto ml-auto">
          <AButton
            className="btn-left-0"
            variant="primary_filled"
            onClick={() => {
              setIsOpenDrawer(false);
            }}
          >
            Apply
          </AButton>
        </div>
      </Drawer>

      <Accordion className="mb-3">
        <AccordionSummary
          expandIcon={<FaAngleDown />}
          aria-controls="Schedule this lecture for other batches"
          id="breakout-header"
        >
          <div className="d-flex align-items-center">
            <Typography className="text-md" style={{ fontWeight: 700 }}>
              Also schedule this lecture for other batches
            </Typography>

            {form?.breakoutBatchList?.length ? (
              <Typography className="text-sm text-bold text-primary ml-2">
                {form.breakoutBatchList.length} batches selected
              </Typography>
            ) : (
              <></>
            )}
          </div>
        </AccordionSummary>

        <AccordionDetails>
          <Typography className="text-sm">
            Select additional batches with the same subject and no scheduling
            conflicts:
          </Typography>
          <AButton
            className="btn-left-0 my-2"
            variant="primary_filled"
            onClick={() => {
              setIsOpenDrawer(true);
            }}
          >
            Select Batches
          </AButton>

          {form?.breakoutBatchList?.length ? (
            <div>
              <p className="text-sm text-bold mb-2">Selected batches:</p>

              {form.breakoutBatchList.map((batch) => (
                <div
                  className="border d-flex justify-content-between align-items-center mt-1"
                  key={batch.value}
                >
                  <p className="text-sm mb-0 ml-2">{batch.label}</p>
                  <IconButtonWrapper
                    onClick={() => {
                      removeSelectedBatch(batch);
                    }}
                  >
                    <CrossIcon />
                  </IconButtonWrapper>
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default MultiBatchLectureAccordion;
